module.exports = __webpack_public_path__ + "static/media/17UN-Women1.6aaa5643.jpg";